<template>
  <div class="bell-log-page">
    <div class="page-search-block">
      <!-- <span class="w-90 inline-block align-r m-r-8 m-b-10">高级筛选：</span> -->
      <div class="inline-block m-b-10">
        <span class="w-110 inline-block align-r">推送中心名称：</span>
        <el-input class="w-120 m-r-8" v-model="filters.search.pushName" placeholder="请输入" ></el-input>
      </div>
      <div class="inline-block m-b-10">
        <span class="w-90 inline-block align-r">部署区域：</span>
        <el-input class="w-120 m-r-8" v-model="filters.search.pushArea" placeholder="请输入" ></el-input>
      </div>
      <div class="inline-block m-b-10">
        <span class="w-90 inline-block align-r">数据类型：</span>
        <el-select class="w-120 m-r-8" v-model="filters.search.dataType" >
          <el-option v-for="item in dataTypeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </div>
      <div class="inline-block m-b-10">
        <span class="w-90 inline-block align-r">数据记录ID：</span>
        <el-input class="w-120 m-r-8" v-model="filters.search.allDataId" placeholder="请输入"></el-input>
      </div>
      <div class="inline-block m-b-10">
        <span class="w-90 inline-block align-r">数据时间：</span>
        <el-date-picker
          :unlink-panels="true"
          class="w-120 m-r-8"
          v-model="filters.search.dataTimeRange"
          type="datetimerange"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="YYYY-MM-DD HH:mm"
          value-format="YYYY-MM-DD HH:mm"
        >
        </el-date-picker>
      </div>
      <div class="inline-block m-b-10">
        <span class="w-90 inline-block align-r">推送时间：</span>
        <el-date-picker
          class="w-120 m-r-8"
          v-model="filters.search.pushTime"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <el-button class="submit-btn m-l-10 m-b-10" size="large" type="primary" @click="handleSearch">搜 索</el-button>
    </div>
    
    <div class="page-operate-block">
      <div class="tit">推送日志列表</div>
    </div>
    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      ></r-table>
    </div>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'
export default {
  name: 'bellLogPage',
  mixins: [tableMix, checkMix],
  components: { RTable },
  data() {
    let dataTypeList = [{name:'平台信息',code:'901'},{name:'经营者信息',code:'902'},{name:'从业人员信息',code:'912'},{name:'房源信息',code:'903'},{name:'房源照片信息',code:'904'},{name:'订单信息',code:'905'},{name:'实际入住人信息',code:'907'},{name:'设备信息',code:'908'},{name:'开锁记录',code:'909'},{name:'设备状态',code:'910'},{name:'门铃抓拍记录',code:'911'},{name:'用户手机软硬件信息',code:'913'}]
    let dataTypeMap = {}
    dataTypeList.map((item)=>{
      dataTypeMap[item.code] = item.name
    })


    return {
      tableVarity: 'equiplog_bell_log',
      tableColumn: [],
      tableData: [],

      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: {pushName:'',pushArea:'', dataType: '', allDataId: '', pushStartTime: '',pushEndTime:'',pushTime:'',dataTimeRange:'' } },
      selOptions: {
      },
      /*平台信息、经营者信息、从业人员信息、房源信息、房源照片信息、订单信息、实际入住人信息、设备信息、开锁记录、设备状态、门铃抓拍记录、用户手机软硬件信息*/
      dataTypeList:dataTypeList,
      dataTypeMap:dataTypeMap,
      defaultTime:[new Date(new Date(new Date().toLocaleDateString()).getTime()),new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)]
    }
  },
  created() {
    this.initTableColumns()
    this.getQuery()
  },
  methods: {
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryParams2()
      console.log(params,this.filters.search,'pp----')
      if(this.filters.search.dataTimeRange && this.filters.search.dataTimeRange[0]){
        params.pushStartTime = this.filters.search.dataTimeRange[0]
        params.pushEndTime = this.filters.search.dataTimeRange[1]
      }
      if(params.pushTime){
        params.updateDateStart = params.pushTime+' 00:00:00'
        params.updateDateEnd = params.pushTime+' 23:59:59'
      }
      delete params.pushTime

      let url = 'PUSH.SYSTEM_DATAPUSH_LOG'
      this.fetchData({
        url,
        method: 'get',
        flag:true,
        params
      })
        .then((res) => {
          this.options.loading = false
          if (this.toExcel == true) {
            if (!res || !res.code) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = res.data.data || []
            this.pagination.total = res.data.rowCount
          }
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },
    // 初始化自定义表头
    initTableColumns() {
      // 表头 visible：默认可见；isInput：表头是否输入框；isSelect：表头是否下拉框
      let columns = [
        { prop: 'pushName', label: '推送中心名称', visible: true, minWidth: 160, isInput: true },
        { prop: 'pushArea', label: '部署区域', visible: true, minWidth: 160, isInput: true },
        { prop: 'dataType', label: '数据类型', visible: true, minWidth: 160, isInput: true },
        { prop: 'pushCount', label: '数量', visible: true, minWidth: 160, isInput: true },
        { prop: 'allDataId', label: '数据记录ID', visible: true, minWidth: 160, isInput: true },
        { prop: 'pushStartTime', label: '数据起始时间', visible: true, minWidth: 160, isInput: true },
        { prop: 'pushEndTime', label: '数据截止时间', visible: true, minWidth: 300, isInput: true },
        { prop: 'updateTime', label: '推送时间', visible: true, minWidth: 200, isInput: true },
        { prop: 'pushResult', label: '推送结果', visible: true, minWidth: 200 },
        { prop: 'reason', label: '失败原因', visible: true, minWidth: 200 },
      ]

      columns.forEach((item) => {
        if (item.prop === 'provinceName') {
          item.render = (row, index, column) => {
            return <div>{row['provinceName']}{row['cityName']}{row['regionName']} </div>
          }
        } else if (item.prop === 'pushResult') {
          item.render = (row, index, column) => {
            let maps = {0:'失败', 1:'成功', 2:'未配置推送地址'}
            return <div>{row['pushResult']?maps[row['pushResult']]:'失败'} </div>
          }
        } else if (item.prop === 'dataType') {
          item.render = (row, index, column) => {
            return <div>{this.dataTypeMap[row['dataType']]} </div>
          }
        } else {
          item.render = (row, index, column) => {
            if (row[item.prop] === '' || row[item.prop] == null) return <span>--</span>
            return <span>{row[item.prop]}</span>
          }
        }

      })

      this.tableColumn = columns
    },
    setTimeRange(val){
      if(val){
        this.filters.search.pushStartTime = val[0]
        this.filters.search.pushEndTime = val[1]
      }else{
        this.filters.search.pushStartTime = ''
        this.filters.search.pushEndTime = ''
      }

    }
  }
}
</script>

<style lang="less" scoped>
.log-title {
  font-size: 22px;
  font-weight: 600;
}
</style>

<style lang="less">
.bell-log-page {
  .default-table-img {
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/img/noimage.png');
    background-size: cover;
  }
}
</style>
